<script>
    import { getContext, onMount } from 'svelte';
    import { Policy, Language } from "@Store";
    import { replace, push, location } from 'svelte-spa-router';
    import translations from "../utils/translations.js";

    const translationMap = {};
    translations.forEach(item => {
        if (item.eng && item.fr) translationMap[item.eng] = item.fr;
    });
    $: t = (text) => ($Language === 'fr' && translationMap[text]) ? translationMap[text] : text;

    const CONTEXT = getContext('CONTEXT');

    let consent = false;

    // Reset consent every time we navigate to this page
    $: if ($location) {
        consent = false;
    }

    onMount(async () => {
        if ($Policy && !$Policy.valid) {
            console.log('NOT Policy >>>>>>>>>>>>>', $Policy);
            console.log('Policy is not valid, redirecting to applicant page');
            push(`/${$Policy.uuid}/applicant`);
            return;
        }
        if ($Policy?.uuid) {
            await CONTEXT.handleUpdateDeclaration(false);
        }
    });

    async function goToSummary() {
        await CONTEXT.handleUpdateDeclaration(true);
        replace(`/${$Policy.uuid}/summary`);
    }

    async function goBack() {
        replace(`/${$Policy.uuid}/priorinsuranceandclaims`);
    }
</script>

<div class="declaration-page">
    <div class="declaration-header">
        <h1>{t($Language === 'fr' ? "Déclaration et consentement de l'assuré" : "Applicant Declaration and Consent")}</h1>
    </div>

    <div class="section">
        <h2 class="section-title">{t($Language === 'fr' ? "Consentement – Pour la cotation" : "Consent – For Quoting")}</h2>
        <p class="section-text">
            {t($Language === 'fr' ? "Je confirme que toutes les informations que j'ai fournies en relation avec cette demande, y compris toutes les informations ou documents pris en charge, sont vraies, complètes et précises au mieux de ma connaissance. Je comprends que ces informations seront utilisées par l'assureur et l'administrateur du programme (Insurance Program Managers Groups & Associations) pour déterminer mon admissibilité à la couverture, les termes de la couverture et le montant de la prime." : "I confirm that all information I have provided in connection with this application, including any supporting information or documents, is true, complete, and accurate to the best of my knowledge. I understand that this information will be relied upon by the insurer and the program administrator (being Insurance Program Managers Groups & Associations) to confirm my eligibility for coverage and to provide an accurate quote.")}
        </p>
        <p class="section-text">
            {t($Language === 'fr' ? "J'autorise l'assureur et le programmeur à examiner, vérifier et valider les informations que j'ai fournies, y compris en collectant et en partageant des informations auprès de tiers lorsque cela est nécessaire pour confirmer mon admissibilité ou mon statut professionnel. Je comprends que toute fausse déclaration, omission ou déclaration inexacte faite ou incluse dans ma demande peut affecter mon admissibilité à la couverture ou résulter dans un devis revu." : "I authorize the insurer and program administrator to review, verify, and validate the information I have provided, including by collecting and sharing information from third parties where necessary to confirm my eligibility or professional status. I understand that any misrepresentation, omission, or inaccurate statement made or included in my application may affect my eligibility for coverage or result in a revised quote.")}
        </p>
    </div>

    <div class="consent-check">
        <label class="consent-card">
            <input type="checkbox" bind:checked={consent} />
            <div class="consent-content">
                <div class="consent-label">{t($Language === 'fr' ? "En continuant, je confirme que j'ai lu, compris et accepté les termes ci-dessus." : 'By proceeding, I confirm that I have read, understood, and agree to the above.')}</div>
            </div>
        </label>
    </div>

    <div class="actions">
        <button class="back-btn" on:click={goBack}>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.5 15L7.5 10L12.5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            {t($Language === 'fr' ? "Retour" : 'Back')}
        </button>
        <button class="primary" on:click={goToSummary} disabled={!consent}>
            {t($Language === 'fr' ? "Continuer" : 'Continue')}
        </button>
    </div>
    {#if !consent}
        <div class="hint">{t("Please accept the declaration to continue.")}</div>
    {/if}
</div>

<style>
    .declaration-page {
        max-width: 820px;
        margin: 0 auto;
        padding: 2rem 1rem 3rem;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
    }

    .declaration-header {
        text-align: center;
        margin-bottom: 2rem;
    }

    .declaration-header h1 {
        margin: 0;
        font-size: 1.75rem;
        letter-spacing: -0.02em;
        color: #1d1d1f;
        font-weight: 700;
    }

    .section {
        background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
        border: 2px solid #e9ecef;
        border-radius: 20px;
        padding: 1.5rem;
        margin-bottom: 1.25rem;
        box-shadow: 0 4px 20px rgba(0,0,0,0.04);
    }

    .section-title {
        margin: 0 0 1rem 0;
        font-size: 1.2rem;
        font-weight: 700;
        color: #1d1d1f;
        letter-spacing: -0.02em;
    }

    .section-text {
        color: #1d1d1f;
        opacity: 0.85;
        line-height: 1.7;
        margin: 0 0 1rem 0;
        font-size: 0.95rem;
    }

    .section-text:last-child {
        margin-bottom: 0;
    }

    .consent-check {
        margin-top: 1.5rem;
    }

    .consent-card {
        display: flex;
        gap: 0.875rem;
        align-items: flex-start;
        background: linear-gradient(135deg, #fff7e6 0%, #fff 100%);
        border: 2px solid #ffe2b6;
        border-radius: 16px;
        padding: 1.25rem;
        cursor: pointer;
    }

    .consent-card input[type="checkbox"] {
        width: 20px;
        height: 20px;
        accent-color: var(--base-green);
        margin-top: 2px;
        flex-shrink: 0;
    }

    .consent-label {
        font-weight: 600;
        color: #1d1d1f;
        line-height: 1.5;
    }

    .actions {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 1rem;
        margin-top: 1.5rem;
    }

    .back-btn {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        padding: 0.75rem 1.5rem;
        font-size: 1rem;
        font-weight: 500;
        border: none;
        border-radius: 10px;
        cursor: pointer;
        background: transparent;
        color: var(--base-green);
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
    }

    .back-btn:hover {
        background: rgba(172, 212, 172, 0.3);
    }

    .primary {
        background: linear-gradient(135deg, var(--base-green) 0%, var(--base-green-light) 100%);
        border: 2px solid var(--base-green);
        border-radius: 14px;
        padding: 0.875rem 2rem;
        cursor: pointer;
        font-size: 1rem;
        font-weight: 700;
        color: #fff;
        transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
        letter-spacing: -0.01em;
        box-shadow: 0 6px 20px rgba(49, 104, 50, 0.25);
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
    }

    .primary:hover:not([disabled]) {
        transform: translateY(-2px);
        box-shadow: 0 10px 28px rgba(49, 104, 50, 0.35);
    }

    .primary:disabled {
        opacity: 0.6;
        cursor: not-allowed;
        box-shadow: none;
    }

    .hint {
        color: #6b7280;
        font-size: 0.95rem;
        text-align: right;
        margin-top: 0.75rem;
    }
</style>
